import { useEffect, useState } from 'react'
import './splash.css'
import { motion, AnimatePresence } from 'framer-motion'
function Splash() {
    const [isOpen, setIsOpen] = useState(true)

    useEffect(() => {
        const x = setTimeout(() => {
            setIsOpen(false)
        }, 4000)

        return () => {
            clearTimeout(x)
        }
    }, [])
    return <div>
        <AnimatePresence>
            {isOpen &&
                <motion.div className="splash"
                    exit={{
                        opacity: 0,
                        scale: 2
                    }}
                    transition={{
                        duration: .5
                    }}
                    onClick={() => setIsOpen(p => !p)}>
                    <div className='splash'>

                        <h1 className='name'>
                            <span>H</span>
                            <span>A</span>
                            <span>I</span>
                            <span>D</span>
                            <span>A</span>
                            <span>R</span>
                        </h1>
                        <h2 className='welcom'>welcom to my portfolio</h2>
                    </div>

                </motion.div>
            }
        </AnimatePresence>
    </div>
}
export default Splash